module.exports = __webpack_public_path__ + "img/c5-1.f9c3616a.jpg";